import { render, staticRenderFns } from "./mocktest_tab.vue?vue&type=template&id=670c584b&scoped=true&"
import script from "./mocktest_tab.vue?vue&type=script&lang=js&"
export * from "./mocktest_tab.vue?vue&type=script&lang=js&"
import style0 from "./mocktest_tab.vue?vue&type=style&index=0&id=670c584b&scoped=true&lang=css&"
import style1 from "./mocktest_tab.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c584b",
  null
  
)

export default component.exports